import { render, staticRenderFns } from "./LS.vue?vue&type=template&id=4af3c84c&scoped=true&"
import script from "./LS.vue?vue&type=script&lang=js&"
export * from "./LS.vue?vue&type=script&lang=js&"
import style0 from "./LS.vue?vue&type=style&index=0&id=4af3c84c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af3c84c",
  null
  
)

export default component.exports